import { render } from "./OwnerInfoPage.vue?vue&type=template&id=0992f261&scoped=true"
import script from "./OwnerInfoPage.vue?vue&type=script&lang=js"
export * from "./OwnerInfoPage.vue?vue&type=script&lang=js"

import "./OwnerInfoPage.vue?vue&type=style&index=0&id=0992f261&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0992f261"

export default script